import { all } from 'redux-saga/effects';
import { watchAuth } from './authSaga';
import { watchOrders } from '../../containers/PurchaseOrder/saga';
import  productSaga  from './productSaga';
import  {auditLogSaga}  from './auditLogSaga';
import vendorSaga from './vendorSaga';
import watchHome from './homeSaga';
import deliveryAddressSaga from './deliveryAddressSaga';
import udhyamCategorySaga from './udhyamCategorySaga';
import productCategorySaga from './productCategorySaga';
import firmNameSaga from './firmNameSaga';
import rbacSaga from './rbacSaga';
import deliveryChallanSaga from './deliveryChallanSaga';
import billReceiptSaga from './billReceiptSaga';
import analyticsSaga from './analyticsSaga';
import paymentSaga from './paymentSaga';
import vendorPerformanceSaga from './vendorPerformanceSaga';
import approvalSaga from './approvalSaga';
import priceHistorySaga from './priceHistorySaga';
import quotationSaga from './quotationSaga';
import returnOrderSaga from './returnOrderSaga';

export default function* rootSaga() {
  yield all([
    watchAuth(),
    watchOrders(),
    productSaga(),
    vendorSaga(),
    auditLogSaga(),
    watchHome(),
    deliveryAddressSaga(),
    udhyamCategorySaga(),
    productCategorySaga(),
    firmNameSaga(),
    rbacSaga(),
    deliveryChallanSaga(),
    billReceiptSaga(),
    analyticsSaga(),
    paymentSaga(),
    vendorPerformanceSaga(),
    approvalSaga(),
    priceHistorySaga(),
    quotationSaga(),
    returnOrderSaga(),
  ]);
}
